<!-- LoadingSection -->
<!-- A 'loading' indicator which is displayed when isLoading is true (default).  When not loading the default slot is rendered. -->
<!-- FUTURE: Allow different loading icons -->
<script lang="ts" setup>
    import { computed } from 'vue';

    const props = withDefaults(defineProps<{
            isLoading: boolean,
            loadingMsg: string
    }>(), {
        isLoading: true,
        loadingMsg: ""
    });

    const loadingMessage = computed<string>(() =>
        {
            if (props.loadingMsg?.length > 0)
                return props.loadingMsg;

            return props.loadingMsg ?? "Loading...";
        });
</script>

<style scoped>
 fieldset 
 { 
     border: 1px solid lightgray; 
     margin-bottom: 1em; 
     border-radius: 0.25em; 
     padding: 0.5em;
 }

 fieldset:hover
 {
     background-color: ghostwhite;
 }
</style>

<template>

    <span v-if="isLoading">
        <i class="fa-solid fa-spinner fa-spin" aria-hidden="true" style="margin-right:.25em"></i>

        <span>{{loadingMessage}}</span>
    </span>
    <span v-else>
        <slot></slot>
    </span>

</template>